import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import { initThemeFromPrefs } from './themes/themeSwitcher';
import { handleDeepLinkRefresh } from './utils/versionCheck';
import { initPwaUpdateCheck } from './utils/pwaUpdate';

// Initialize theme before app renders
initThemeFromPrefs();

// PWA: Check for app updates (iOS and standalone)
initPwaUpdateCheck(30);

// Handle deep link refresh for iOS PWA
handleDeepLinkRefresh();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} closeOnClick pauseOnHover />
    </BrowserRouter>
  </React.StrictMode>
);